<template>
  <div
    class="asc-fleet-fault-msg-tab-2-wrapper"
    data-automation-id="wrapper_fleet_fault_msgs_tab_2"
  >
    <div class="asc-fleet-fault-msg-tab-2-wrapper--content">
      <div class="asc-fleet-fault-msg-tab-1-wrapper--content-filter">
        <asc-chips-filter-manager
          :default-filter-options="faultReportsDefaultFilterOptions"
          @filterChanged="handleFaultReportsFiltersChange"
        ></asc-chips-filter-manager>
      </div>

      <div class="asc-fleet-fault-msg-tab-2-wrapper--content-table">
        <asc-fault-report-by-flight-grid-wrapper
          title="Fault Reports By Flight"
          :values="faultReportsByFlightData"
          :on-open-raw-report="onOpenRawReport"
          :on-view-details="onViewDetails"
        ></asc-fault-report-by-flight-grid-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
import AscChipsFilterManager from '@/components/molecules/AscChipsFilterManager'
import { AscFaultReportByFlightGridWrapper } from '@/components/organisms'

export default {
  name: 'AscFleetFaultMsgTab1Wrapper',

  components: {
    AscChipsFilterManager,
    AscFaultReportByFlightGridWrapper,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    faultReportsByFlightData: {
      type: Array,
      default: () => [],
    },
    faultReportsDefaultFilterOptions: {
      type: Array,
      default: () => [],
    },
    onFaultReportsFiltersChange: {
      type: Function,
      default: () => {},
    },
    onOpenRawReport: {
      type: Function,
      default: () => {},
    },
    onViewDetails: {
      type: Function,
      default: () => {},
    },
  },

  methods: {
    handleFaultReportsFiltersChange(filters) {
      if (this.onFaultReportsFiltersChange) {
        this.onFaultReportsFiltersChange(filters)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-fleet-fault-msg-tab-2-wrapper {
  .asc-fleet-fault-msg-tab-2-wrapper--content {
    .asc-fleet-fault-msg-tab-2-wrapper--content-chips {
      margin-bottom: 16px;
    }

    &-tail {
      margin: 16px 0;
      padding: 8px;
      border: 1px solid $gray-300;
    }
  }

  .asc-fleet-fault-msg-tab-2-wrapper--content-table {
    margin-top: 16px;
    padding: 16px 16px 8px 16px;
    border: 1px solid $gray-300;
  }
}
</style>
